import { render, staticRenderFns } from "./ErrorLanding.vue?vue&type=template&id=2a2f506b"
import script from "./ErrorLanding.vue?vue&type=script&lang=js"
export * from "./ErrorLanding.vue?vue&type=script&lang=js"
import style0 from "./ErrorLanding.vue?vue&type=style&index=0&id=2a2f506b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports